export const translations = {
    tr: {
        quizResults: 'Quiz Sonuçları',
        downloadExcel: 'Excel İndir',
        quizType: 'Quiz Tipi',
        bigSection: 'Ana Bölüm',
        section: 'Bölüm',
        questionNumber: 'Soru #',
        question: 'Soru',
        yourAnswer: 'Cevabınız',
        targetValue: 'Hedef Değer',
        companyName: 'Şirket Adı',
        companyNotFound: 'Şirket bulunamadı.',
        companyNameRequired: 'Şirket adı boş olamaz.',
        serverError: 'Sunucuya bağlanırken bir hata oluştu. Lütfen tekrar deneyin.',
        companyCreateError: 'Şirket oluşturulamadı.',
        welcomeTitle: 'Startup Olgunluk ve Gelecek Durum Değerlendirme Sistemine Hoşgeldiniz!',
        welcomeDescription: 'Bu sistem, geliştirmiş olduğumuz özel bir model ile kurumunuzu uçtan uca analiz ederek şu anki durumunu ve geleceğe ne kadar hazır olduğunu derinlemesine analiz etmekte, bununla birlikte güçlü ve zayıf alanlarınızı, ihtiyaçlarınızı, iyileşme ve gelişim alanlarınızı ve en önemlisi gelecek için keşif alanlarınızı ortaya çıkarmaktadır.',
        username: 'Kullanıcı Adı',
        password: 'Şifre',
        loginFailed: 'Giriş başarısız.',
        target: 'Hedef',
        startup: 'Startup',
        nonExistent: '1 - Var Olmayan',
        firstStage: '2 - İlk Aşama',
        developing: '3 - Gelişmekte Olan',
        mature: '4 - Olgunlaşmış',
        advanced: '5 - İleri Düzey',
        enterCompanyName: 'Şirket Adı',
        continueButton: 'Devam Et',
        saveButton: 'Kaydet',
        companyNamePlaceholder: 'Şirket Adı',
        welcomeTechTitle: 'Teknoloji ve Dijital Olgunluk Aracı\'na Hoşgeldiniz!',
        welcomeTechDescription: 'Bu sistem, geliştirmiş olduğumuz özel bir model ile kurumunuzun teknoloji altyapısını, dijital olgunluğunu ve yeni teknoloji uyumunu uçtan uca analiz ederek şu anki durumunu ve geleceğe ne kadar hazır olduğunu derinlemesine analiz etmekte, bununla birlikte güçlü ve zayıf alanlarınızı, ihtiyaçlarınızı, iyileşme ve gelişim alanlarınızı ortaya çıkarmaktadır.',
        startButton: 'Başla',
        usernamePlaceholder: 'Kullanıcı Adı',
        passwordPlaceholder: 'Şifre',
        loginButton: 'Giriş',
        loginError: 'Sunucuya bağlanırken hata oluştu.',
        innovationTitle: 'İnovasyon\nAr-Ge',
        technologyTitle: 'Teknoloji',
        sustainabilityTitle: 'Sürdürülebilirlik',
        strategyTitle: 'Strateji',
        startQuiz: 'Başla',
        resultsTitle: 'Sonuçlar',
        questionDescription: 'Soru Açıklaması',
        targetValueDescription: 'Hedef Değer Açıklaması',
        nextQuestion: 'Sonraki Soru',
        previousQuestion: 'Önceki Soru',
        finishQuiz: 'Quiz\'i Bitir'
    },
    en: {
        quizResults: 'Quiz Results',
        downloadExcel: 'Download Excel',
        quizType: 'Quiz Type',
        bigSection: 'Big Section',
        section: 'Section',
        questionNumber: 'Question #',
        question: 'Question',
        yourAnswer: 'Your Answer',
        targetValue: 'Target Value',
        companyName: 'Company Name',
        companyNotFound: 'Company not found.',
        companyNameRequired: 'Company name cannot be empty.',
        serverError: 'An error occured connecting to server. Please try again.',
        companyCreateError: 'Failed to create company.',
        welcomeTitle: 'Welcome to the Startup Maturity & Future State Assessment System!',
        welcomeDescription: 'This system analyzes your institution end-to-end with a special model we have developed, how ready it is for current protection and developments, and reveals your strong and weak areas, your needs, your areas of improvement and development, and most importantly, your cycle areas for the future.',
        username: 'Username',
        password: 'Password',
        loginFailed: 'Login failed.',
        target: 'Target',
        startup: 'Startup',
        nonExistent: '1 - Non-Existent',
        firstStage: '2 - First Stage',
        developing: '3 - Developing',
        mature: '4 - Mature',
        advanced: '5 - Advanced',
        enterCompanyName: 'Company Name',
        continueButton: 'Continue',
        saveButton: 'Save',
        companyNamePlaceholder: 'Company Name',
        welcomeTechTitle: 'Welcome to Technology and Digital Maturity Tool!',
        welcomeTechDescription: 'This system performs an end-to-end analysis of your organization\'s technology infrastructure, digital maturity, and new technology compatibility using our specially developed model, analyzing its current state and how ready it is for the future, while revealing your strengths, weaknesses, needs, and areas for improvement and development.',
        startButton: 'Start',
        usernamePlaceholder: 'Username',
        passwordPlaceholder: 'Password',
        loginButton: 'Login',
        loginError: 'Error connecting to server.',
        innovationTitle: 'Innovation\nR&D',
        technologyTitle: 'Technology',
        sustainabilityTitle: 'Sustainability',
        strategyTitle: 'Strategy',
        startQuiz: 'Start',
        resultsTitle: 'Results',
        questionDescription: 'Question Description',
        targetValueDescription: 'Target Value Description',
        nextQuestion: 'Next Question',
        previousQuestion: 'Previous Question',
        finishQuiz: 'Finish Quiz'
    }
};

export const getText = (key) => {
    const language = localStorage.getItem('language') || 'tr';
    return translations[language][key] || key;
};
